import React, { useEffect, useMemo, useState } from 'react';
import './index.less';
import { businessSettingsDisplay } from '@/lib/service/common';
import { BusinessSettingConfigKey } from '@/shared/types/business-setting';
import { IReview } from '@/shared/types/ui';
import { Carousel } from 'antd';
import { LeftOutlined, RightOutlined } from '@/components/Common/Icons';
import Image from 'next/image';
import { imageTransform } from '@/shared/utils/utils';

const SupplierReviewsCarousel = ({ signup }: { signup: () => void }) => {
  const [reviews, setReviews] = useState<IReview[]>([]);

  useEffect(() => {
    businessSettingsDisplay(BusinessSettingConfigKey.SUPPLIER_REVIEWS).then((data) => {
      setReviews(data?.value ?? []);
    });
  }, []);

  const sliderSettings = useMemo(
    () => ({
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
      slidesToScroll: 1,
      draggable: false,
      autoplay: true,
      autoplayTimeout: 2000,
      arrows: true,
      nextArrow: <RightOutlined />,
      prevArrow: <LeftOutlined />,
    }),
    [],
  );

  const renderReviewCard = (info: IReview, index: number) => {
    return (
      <div className="testimonial" key={index}>
        <div className="inner">
          <div className="text">
            <div className="top">
              <div className="name-wrapper">
                <span className="name">{info.supplierName}</span>
                <Image width={75} height={75} src={imageTransform(info.supplierImage, 'large')} alt="supplierImage" />
              </div>
              <span className="quote">{info.quote}</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="supplier-reviews">
      <span className="title">The Reviews Are In</span>
      <Carousel {...sliderSettings} rootClassName="carousel">
        {reviews.map((review, i) => renderReviewCard(review, i))}
      </Carousel>
      <span className="action-button" onClick={signup}>
        Sign Up Now
      </span>
    </div>
  );
};

export default SupplierReviewsCarousel;
